// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AddToBasket_wrapper__8wnd4","outOfStock":"AddToBasket_outOfStock__TPm7z"};